import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  orderCurrencyCodeById,
  orderShippingPriceById,
  orderSubtotalById,
  orderTaxById,
  orderTotalById,
} from '/redux/selector/client.selector';

import SummarySection from './SummarySection';

export default connect(
  createStructuredSelector({
    currencyCode: orderCurrencyCodeById,
    subtotal: orderSubtotalById,
    shipping: orderShippingPriceById,
    tax: orderTaxById,
    total: orderTotalById,
  }),
)(SummarySection);
